import { ACCESS_RIGHTS } from "@/constants/accessRights";

export var peopleSyncMenuItems = [
    {
        id: "peoplesync",
        label: "PeopleSync",
        icon: "ri-team-fill",
        link: "/#",
        subItems: [
            { id: "peoplesync-dashboard-main", label: "Dashboard", icon: "ri-bar-chart-2-fill", link: "/peoplesync/dashboards/main", permissionTypeId: [] },
            { id: "peoplesync-employees", label: "Employees", icon: "ri-contacts-fill", link: "/peoplesync/employees", permissionTypeId: [ACCESS_RIGHTS.PEOPLESYNC_EMPLOYEES] },
            { id: "peoplesync-plantilla", label: "Plantillas", icon: "ri-file-list-2-fill", link: "/peoplesync/plantilla", permissionTypeId: [] },
            { id: "peoplesync-applicants", label: "Applicant Pool", icon: "ri-user-search-fill", link: "/peoplesync/applicants", permissionTypeId: [] },
           
            { id: "peoplesync-learning-development", label: "Learning and Development", icon: "ri-graduation-cap-fill", link: "/peoplesync/learning-development", permissionTypeId: [] },
            { id: "peoplesync-emp-learning-development", label: "My Learning and Development", icon: "ri-graduation-cap-fill", link: "/peoplesync/emp-learning-development", permissionTypeId: [] },
            
            { id: "peoplesync-goal-settings", label: "Goal Setting", icon: "ri-focus-3-fill", link: "/peoplesync/goal-settings", permissionTypeId: [] },
            { id: "peoplesync-emp-goal-settings", label: "My Goal Setting", icon: "ri-focus-3-fill", link: "/peoplesync/emp-goal-settings", permissionTypeId: [] },

            { id: "peoplesync-performance-evaluation", label: "Performance Evaluation", icon: "ri-bar-chart-fill", link: "/peoplesync/performance-evaluation", permissionTypeId: [] },
            { id: "peoplesync-reward-recognition", label: "Rewards & Recognition", icon: "ri-award-fill", link: "/peoplesync/reward-recognition", permissionTypeId: [] },
            
            { id: "peoplesync-employee-attendance", label: "Employee Attendance", icon: "ri-calendar-check-fill", link: "/peoplesync/employee-attendance", permissionTypeId: [] },
            { id: "peoplesync-my-attendance", label: "My Attendance", icon: "ri-calendar-check-fill", link: "/peoplesync/my-attendance", permissionTypeId: [] },
            
            { id: "peoplesync-employee-leave-summary", label: "Leave Summary", icon: "ri-calendar-2-fill", link: "/peoplesync/leave-summary", permissionTypeId: [] },
            { id: "peoplesync-my-leave-summary", label: "My Leave Summary", icon: "ri-calendar-2-fill", link: "/peoplesync/my-leave-summary", permissionTypeId: [] },

            {
                id: "peoplesync-transactions", label: "My Transactions", icon: "ri-file-transfer-fill",
                link: "/peoplesync/transactions",
                permissionTypeId: [
                ],
            },
            { id: "peoplesync-reports", label: "Reports", icon: "ri-article-line", link: "/peoplesync/reports", permissionTypeId: [] },
            {
                id: "peoplesync-settings", label: "Settings", icon: "ri-settings-2-fill",
                link: "/peoplesync/staticdata",
                permissionTypeId: [
                    ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_BRANCHES, ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_DEPARTMENTS,
                    ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_EDUCATIONLEVELS, ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_EMPLOYMENTTYPES,
                    ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_HOLIDAYTYPES, ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_LEAVETYPES,
                    ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_NATIONALITIES, ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_PLANTILLAS,
                    ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_POSITIONS, ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_RELATIONSHIPTYPES,
                    ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_SALARIES, ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_SALARYTYPES,
                    ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_SCHOOLS, ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_SEPARATIONCAUSETYPES,
                    ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_SERVICERECORDTYPES, ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_SKILLS,
                    ACCESS_RIGHTS.PEOPLESYNC_STATICDATA_WORKSCHEDULES,
                ],
            },
        ],
    },
];